export class EventFormDefinition {
  id:string
  formId:string
  name:string
  templateListItem:string
  repeatable: boolean
  required:boolean
  templateListItemIcon:string
  templateListItemPrimary:string
  templateListItemSecondary:string
  constructor() {
  }
}